<span class="min-max float-start text-muted">{{ min }}</span>
<span class="min-max float-end text-muted">{{ max }}</span>
